import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import checkExistence from '@nykaa/auth-shared/store/actions/checkExistence';
import { logger } from '@nykaa/logger';
import { pushEvent } from '@nykaa/data-layer';
import { isPhoneNumber } from '@nykaa/auth-shared/utils';
import {
  AUTH_EVENTS,
  CHECK_EXISTANCE_CAPTCHA_ERROR,
} from '@nykaa/auth-shared/constants';
import { CheckExistenceServiceProps } from '@nykaa/auth-shared/store/types';
import { executeCaptcha } from 'helpers/utils/reCaptcha';
import { recaptchaActions } from 'User/store/resetPassword/actionTypes';
import { GetLoginProps } from 'layouts/Auth/types';
import { State } from 'store/types';
import { loginPageName } from 'components/SignUp/helper';
import {
  LOGIN_INTERACTION,
  LOGIN_NUDGE,
  LOGIN_WIDGET,
  WELCOME_PAGE,
} from 'constants/auth';
import { getMobileNumberLocal } from 'helpers/auth';
import { ACCOUNT } from 'shared/constants';
import { useHistory } from 'react-router-dom';

const SIGNUP_PAGE_NAME = 'Msite:Nykaa:signupUpPage';
const NUDGE_PAGE_NAME = 'Msite:Nykaa:signupUpNudge';
const COUPONS_PAGE = 'couponsPage';

export const getLogin = ({
  emailPhone,
  history,
  dispatch,
  setErrorMessage,
  setError,
  name,
  sendOtpToMail,
  isCheckExistenceCaptchaEnabled,
}: GetLoginProps) => {
  let checkExistenceParams: CheckExistenceServiceProps = {
    history,
  };
  const sentOnPhone = isPhoneNumber(emailPhone);
  if (!sentOnPhone) {
    checkExistenceParams = {
      ...checkExistenceParams,
      email: emailPhone,
    };
  } else {
    checkExistenceParams = {
      ...checkExistenceParams,
      mobile_number: emailPhone,
      name,
      sendOtpToMail,
    };
  }
  if (isCheckExistenceCaptchaEnabled) {
    executeCaptcha(recaptchaActions.CHECK_EXISTENCE)
      .then((token: string) => {
        setError(false);
        const captchaParams = {
          captchaResponse: token,
        };
        checkExistenceParams = {
          ...captchaParams,
          ...checkExistenceParams,
        };
        checkExistence(checkExistenceParams)(dispatch);
      })
      .catch((err: Error) => {
        setError(true);
        setErrorMessage(err.message);
        logger.error(err, CHECK_EXISTANCE_CAPTCHA_ERROR);
      });
  } else checkExistence(checkExistenceParams)(dispatch);
};

export const useManageEvents = (showNudge?: boolean) => {
  const isDataFetched = useSelector((state: State) => state.auth.dataFetched);
  const isLoginAutoTriggered = useSelector(
    (state: State) => state.appReducer.isLoginAutoTriggered
  );
  const { WELCOME_SCREEN, NUDGE_SCREEN } = AUTH_EVENTS;
  const history = useHistory();
  const { search: queryString } = history.location;
  const queryParams = new URLSearchParams(queryString);
  const root = queryParams.get('root');

  useEffect(() => {
    if (isDataFetched) {
      const handleLoad = () => {
        const phFill = getMobileNumberLocal() ? 1 : 0;
        let localPageLocation = loginPageName();
        let pageLocation = `${localPageLocation}:${LOGIN_WIDGET}`;
        let pageName = SIGNUP_PAGE_NAME;
        if (showNudge) {
          pageLocation = `${localPageLocation}:${LOGIN_NUDGE}`;
          pageName = NUDGE_PAGE_NAME;
        }
        let interactionLocation = `${localPageLocation}:${
          root || ACCOUNT.default
        }`;
        if (root && root === LOGIN_INTERACTION.COUPON_OFFERS) {
          interactionLocation = `${COUPONS_PAGE}:${LOGIN_INTERACTION.COUPON_OFFERS}`;
          localPageLocation = COUPONS_PAGE;
        }
        pushEvent(WELCOME_SCREEN, {
          pageLocation,
          pageName,
          phFill,
          page: WELCOME_SCREEN,
          pageType: WELCOME_PAGE,
          interactionLocation: interactionLocation,
          nudge_screen_load_location: localPageLocation,
          welcome_screen_type: 'new',
          nudge: showNudge ? 'Yes' : 'No',
          isLoginAutoTriggered: isLoginAutoTriggered,
        });
      };
      const timer = setTimeout(() => {
        handleLoad();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [
    NUDGE_SCREEN,
    WELCOME_SCREEN,
    showNudge,
    isDataFetched,
    root,
    isLoginAutoTriggered,
  ]);
};
